/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
import { Button, Checkbox, FormControlLabel, MenuItem, TextField, makeStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Dialog from 'modules/common/dialog.component';
import Spinner from 'modules/common/spinner.component';
import { convertPhoneNumber } from 'modules/intake/details/authorizationIntake/utils';
import { COUNTRY_CODES } from 'modules/common/countryCodes';

const useStyles = makeStyles((theme) => ({
  mobileNum: {
    marginRight: 10,
  },
  email: {
    minWidth: 175,
  },
  countryCode: {
    maxWidth: 145,
    marginRight: 10,
  }
}));

function WebAccessDialog(props) {
  const classes = useStyles(props);

  const {
    onSubmit,
    onCancel,
    maxLength,
    disabled,
    record,
    ...rest
  } = props;
  
  const [mobileNumber, setMobileNumber] = useState(record ? record.webAccessMobileNumber : '');
  const [primaryEmail, setPrimaryEmail] = useState(record ? record.webAccessEmailAddress : '');
  const [noMobileNum, setNoMobileNum] = useState(false);
  const [grantingAccess, setGrantingAccess] = useState(false);
  const [countryCode, setCountryCode] = useState('');

  let countryOptions = [];
  if (COUNTRY_CODES) {
    countryOptions = COUNTRY_CODES.map((country) => ({
      value: country['alpha-3'],
      label: country.name,
    }));
  }

  const handleSubmit = async () => {
    setGrantingAccess(true);
    await onSubmit(noMobileNum, primaryEmail, mobileNumber);
    setGrantingAccess(false);
    onCancel();
  }

  return (
    <Dialog
      {...rest}
      title="Resend Welcome Email?"
      content={
        <div>
          {props.record && (
            <div>
              {/* <Typography>{`${props.record.contacts[0].firstName} ${props.record.contacts[0].lastName}`}</Typography>
              <Typography>{props.record.client.description}</Typography> */}
              <div>
                <TextField
                  select
                  label="Country"
                  className={classes.countryCode}
                  value={countryCode}
                  onChange={(e) => { setCountryCode(e.target.value); setMobileNumber(convertPhoneNumber(mobileNumber, e.target.value)); }}
                  SelectProps={{
                    autoWidth: true,
                  }}
                  variant="outlined"
                >
                  {countryOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  type="text"
                  name="mobileNumber"
                  label="Mobile Number"
                  variant="outlined"
                  value={convertPhoneNumber(mobileNumber, countryCode)}
                  onChange={(e) => setMobileNumber(convertPhoneNumber(e.target.value, countryCode))}
                  className={classes.mobileNum}
                  disabled={noMobileNum}
                />
                <TextField
                  type="text"
                  name="emailAddress"
                  label="Email Address"
                  variant="outlined"
                  value={primaryEmail}
                  onChange={(e) => setPrimaryEmail(e.target.value)}
                  className={classes.email}
                />
              </div>
              <FormControlLabel
                control={
                  <Checkbox
                    name="confirmNoMobileNum"
                    label="Confirm No Mobile Number"
                    value={noMobileNum}
                    onChange={(e) => setNoMobileNum(!noMobileNum)}
                  />
                }
                label="Confirm No Mobile Number"
                classes={{ root: classes.checkbox }}
              />
            </div>
          )}
          {(!props.record || grantingAccess) && (
            <Spinner />
          )}
        </div>
      }
      actions={
        <>
          <Button disabled={disabled} onClick={onCancel} variant="outlined" color="primary">Cancel</Button>
          <Button disabled={!props.record || grantingAccess} onClick={handleSubmit} variant="contained" color="primary">Grant Access</Button>
        </>
      }
    />
  );
}

WebAccessDialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  record: PropTypes.object,
};

export default compose(
  connect(null, {
    showToast,
  }),
)(WebAccessDialog);